import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';


const CommonBanner = ({ 
    banners, 
    isTablet,
    onBannerClick,
    autoplayDelay = 5000,
    className = "main_visual_swiper banner",
    imageKeys = {
        pc: 'pc_img',
        mobile: 'mobile_img',
        id: 'b_seq'
    }
}) => {
    if (!banners?.length) return null;

    // 배너 클릭 핸들러 추가
    const handleBannerClick = (banner) => {
        // 외부에서 제공한 클릭 핸들러가 있으면 우선 실행
        if (onBannerClick) {
            onBannerClick(banner);
            return;
        }
        
        // 링크가 있는 경우에만 처리
        if (banner.link_url) {
            if (banner.target_type === 'blank') {
                // 새 창에서 열기
                window.open(banner.link_url, '_blank');
            } else {
                // 현재 창에서 이동
                window.location.href = banner.link_url;
            }
        }
    };

    return (
        <Swiper
            modules={[Pagination, Autoplay]}
            pagination={{ clickable: true }}
            autoplay={{ delay: autoplayDelay }}
            slidesPerView="auto"
            loop={true}
            className={className}
        >
            {banners.map((banner, idx) => (
                <SwiperSlide 
                    key={banner[imageKeys.id] || idx}
                    onClick={() => handleBannerClick(banner)}
                >
                    <img
                        src={isTablet && banner[imageKeys.mobile] 
                            ? banner[imageKeys.mobile] 
                            : banner[imageKeys.pc]}
                        alt={`배너 ${idx + 1}`}
                        className="object-cover"
                        loading="lazy"
                    />
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default CommonBanner;